import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { builderJson } from './builderJson';
import type { IBuilderCardProps } from './IBuilderCardProps';

/** «Визначення JSON» конструктора (прототип v4): рядок-кнопка «Показати / Приховати», під ним — визначення типу запису моноширинним текстом. */
export function JsonCard({ module, rt, editor, strings }: IBuilderCardProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  return (
    <section className="rb-card rb-card--flush">
      <button type="button" className="rb-json" aria-expanded={open} onClick={() => setOpen(!open)}>
        <strong>{t('rtBuilder.json')}</strong><span>{t(open ? 'rtBuilder.hide' : 'rtBuilder.show')}</span>
      </button>
      {open && <pre className="rb-json__pre">{JSON.stringify(builderJson(module, rt, editor.patch, strings), null, 2)}</pre>}
    </section>
  );
}
